import React from 'react';
import Link from 'next/link';
import {useRouter} from 'next/router';
import Image from 'next/image';
import { Button } from 'react-bootstrap';
import styles from '../styles/about/CookieConsent.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes} from '@fortawesome/free-solid-svg-icons';
import { setCookie } from './cookieTools';

const PersonalCookieNotice = (props) => {

    const {cookies, close} = props;
    const router = useRouter();

    const saveCookies = () =>{
        let opt = { ...cookies,
            categories: {
                ...cookies.categories,
                personal: 1,
            },
            consentDate: new Date(),
        }
        setCookie('ckconso', JSON.stringify(opt), 90);
        close();
        router.reload(window.location.pathname);
    }


    return (
        <dialog className={styles.root} >
            <div className={styles.dialogOverlay} ></div>
            <div className={styles.container}>
                <div className={styles.consentRoot} >
                    {/* <div className={styles.logo} >
                        <Image src="/images/icons/conso.png" width={70} height={21} alt="Conso" />  
                    </div> */}
                    
                    <p className="heading3 text-center font-weight-bold">
                        Setările de personalizare sunt inactive
                    </p>
                    <p className={styles.infoText}>
                        Fără aceste cookies, <strong>datele completate în formularul de comparații RCA pot fi pierdute</strong>, pe parcursul navigarii în site. Activează aceste cookies pentru o experiență mai bună de utilizare a portalului.
                    </p>

                    <p className={styles.infoText}> 
                        Află mai multe în <Link
                        href={`${process.env.NEXT_PUBLIC_WEB}/termeni/cookies`}
                        title="Politica Cookies"
                        target="_blank">Politica privind cookies</Link>.
                    </p>
                   
                    <div className="d-flex justify-content-around">
                        <Button variant="secondary" onClick={saveCookies}>Activează</Button>
                   
                        <Button variant="link" onClick={close}>
                            <FontAwesomeIcon icon={faTimes} height="16" width="16" className="me-2"/>
                            Închide
                        </Button>
                    </div>
                </div>  
            </div>
        </dialog>
    );
}

export default PersonalCookieNotice;